import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Type declarations are used at compile-time as 'headers' only (does NOT include the files)

import { LogUtils } from "abweb/utils/log/LogUtils";
export class DebugUtils {
  // integration tests on browser farm

  constructor() {
    throw new Error("Static class, cannot create an instance!");
  }

  /**
   * During development, throw exceptions when encountering this type of error,
   * but in production, should simply log the error.
   * Do not use when the error should always be thrown.
   * Also see the Assert class (which internally uses developerError) for assertion support.
   */
  static developerError(err) {
    if (DebugUtils.THROW_ON_DEV_ERROR) {
      // browser will 'console.error' any uncaught exceptions, so don't need to also log it
      const e = new Error(err); // captures call stack
      e.name = DebugUtils.DEV_ERROR;
      throw e;
    }
    // Always log (as opposed to console.error), so that error will be captured for PFS.
    // Note that LOG.error also captures the stack trace.
    DebugUtils.LOG.error(err);
  }
  static logAndThrowError(errMsg) {
    DebugUtils.LOG.error(errMsg);
    throw new Error(errMsg);
  }
}
// do NOT use AbWebServices.getAbWebLogger or get circular static dependency
_defineProperty(DebugUtils, "LOG", LogUtils.getLogger(__filename));
_defineProperty(DebugUtils, "DEV_ERROR", "DevError");
// Do NOT use URLUtils as causes usage before the indexDepth is configured, so (context root) can not yet be correctly calculated
_defineProperty(DebugUtils, "THROW_ON_DEV_ERROR", __RUNTIME_ENV__.ABINITIO_JS_THROW_ON_DEV_ERROR != null || window.location.hostname.indexOf("localhost") >= 0 || window.location.hostname.indexOf("abinitio.com") >= 0);
//# sourceMappingURL=DebugUtils.js.map
